module.exports = __webpack_public_path__ + "img/antes_despues_141.48372f4f.png";